export const InstallmentTimeLimitation = 36;
